import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/catalog";
import SocialButtons from "@/components/shop/SocialButtons";

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-white/10 px-6 py-16 md:px-12"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 md:flex-row md:items-center">
      <div className="flex items-center gap-4">
        <img
          src="/assets/grandline-logo.jpg"
          alt="Grand Line Cards"
          className="h-12 w-12 rounded-full object-cover ring-1 ring-[#cba153]/60"
        />
        <div>
          <p className="font-display text-xl text-[#fafafa]">Grandlinecards</p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">
            Pokémon · One Piece TCG
          </p>
        </div>
      </div>
      <div className="flex items-center gap-5">
        <a
          href={waLink("Ciao! Vorrei informazioni.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-white/60 transition-colors duration-300 hover:text-[#25D366]"
        >
          <MessageCircle size={14} />
          Contattaci su WhatsApp
        </a>
        <SocialButtons testIdPrefix="footer" />
      </div>
      <div className="flex flex-col gap-3 font-mono text-xs text-white/30 md:items-end">
        <div className="flex gap-6">
          <Link
            to="/privacy-policy"
            data-testid="footer-privacy-link"
            className="uppercase tracking-[0.15em] transition-colors duration-300 hover:text-[#cba153]"
          >
            Privacy Policy
          </Link>
          <Link
            to="/termini-e-condizioni"
            data-testid="footer-termini-link"
            className="uppercase tracking-[0.15em] transition-colors duration-300 hover:text-[#cba153]"
          >
            Termini e Condizioni
          </Link>
          <Link
            to="/cookie-policy"
            data-testid="footer-cookie-link"
            className="uppercase tracking-[0.15em] transition-colors duration-300 hover:text-[#cba153]"
          >
            Cookie Policy
          </Link>
        </div>
        <p>© 2026 Grandlinecards</p>
        <p data-testid="footer-piva">P.IVA IT18599661008 · REA 1798990</p>
        <p data-testid="footer-legal-address">
          Viale Libia 58, 00199 Roma (RM) · grandlinecards149@gmail.com
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
